import { render, staticRenderFns } from "./EvaluateResearchGroup.html?vue&type=template&id=ef2cd5ec&scoped=true&"
import script from "./EvaluateResearchGroup.vue?vue&type=script&lang=js&"
export * from "./EvaluateResearchGroup.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateResearchGroup.scss?vue&type=style&index=0&id=ef2cd5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2cd5ec",
  null
  
)

export default component.exports